export const GET_DOCUMENTS = `
query getDocuments(
  $input: GetDocumentsInput!
) {
  getDocuments(
    input: $input
  ) {
    __typename
    ... on Document {
      id
      document_type {
        name
      }
      status {
        translation_key
        color
      }
      filename
      its
    }
    
    ... on ResultError {
      __typename
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const DOCUMENTS_COUNT = `
query getDocumentsCount($input: GetDocumentsInput!) {
  getDocumentsCount(input: $input) {
    __typename
    ... on DocumentCount {
      count
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const GET_DOCUMENT_PDF = `
query getDocumentPdfFile(
  $document_id: Int!
) {
  getDocumentPdfFile(
    document_id: $document_id
  ) {
    __typename
    ... on DocumentPdfResponse {
      file
    }
    
    ... on ResultError {
      __typename
      status_code
      message
      message_translation_key
    }
  }
}`;

export const EXPORT_DOCUMENTS = `
query exportDocuments(
  $input: ExportDocumentInput!
) {
  exportDocuments(
    input: $input
  ) {
    __typename
    ... on ExportResult {
      file
      mimetype
      encoding
      filename 
    }
    
    ... on ResultError {
      __typename
      status_code
      message
      message_translation_key
    }
  }
}`;
